module.exports = __webpack_public_path__ + "img/logo_footer.103213f4.svg";